import React, {useRef, useState} from "react";
import {get} from "lodash";
import useTitle from "../element/useTitle";
import {checkForm} from "../element/Utils";
import {navigate} from "@reach/router";
import Client from "./Client";
import {ClientApi} from "../api/Client";

function ClientCont(props) {
    //const { host } = props;
    const [host] = useState(window.location.hostname);
    const isMondiale = host.includes("mondiale");
    const isMMEA = host.includes("mmea");
    const isClearFog = host.includes("clearfog");
    const isSouter = host.includes("souter");

    const formRef = React.createRef();
    const [submitting, setSubmitting] = useState(false);

    useTitle("Client Registration Form");

    const payload = {
        realm: "RMA Africa"
    };

    async function submit() {
        let newObject = await checkForm(formRef);
        let data = {...newObject, ...payload};
        if (get(data, "accounts.isSameAsRep"))
            data.accounts = {...data.accounts, ...data.representativeContact};

        if (get(data, "coordinator.isSameAsRep"))
            data.coordinator = {...data.coordinator, ...data.representativeContact};

        console.log(data)

        const dataFiles = new FormData();
        fileList.forEach((file, i) => {
            dataFiles.append(`file-${file.category}-${i}`, file.file, `${file.category}-${file.file.name}`);
        });

        dataFiles.append('data', JSON.stringify(data));

        setSubmitting(true);
        try {
            // const submitted = await ClientApi.create(JSON.stringify({dataFiles}));
            //
            await fetch(`https://vendor.rms.africa/api/client/`, {
                method: 'POST',
                body: dataFiles,
            })
            // console.log(submitted);
            // if (submitted) navigate("/Success");
        } catch (e) {
            console.log(e);
        }
        setSubmitting(false);
    }

    const [fileList, setFileList] = useState(null);

    const handleFileChange = (e, category = '') => {

        const filesArray = Array.from(e.target.files).map(file => ({
            file,
            category
        }));
        setFileList(list => [...(list || []), ...filesArray]);
    };

    const handleUploadClick = () => {
        if (!fileList) {
            return;
        }

        // 👇 Create new FormData object and append files
        const data = new FormData();
        fileList.forEach((file, i) => {
            data.append(`file-${file.category}-${i}`, file.file, file.file.name);
        });

    }

    // 👇 files is not an array, but it's iterable, spread to get an array of files
   // const files = fileList ? [...fileList] : [];

    console.log(fileList)

    return (
        <Client
            {...{
                submit,
                submitting,
                host,
                isMondiale,
                isMMEA,
                isClearFog,
                isSouter,
                handleUploadClick,
                files: Array.isArray(fileList) ? [...fileList] : [],
                handleFileChange
            }}
            ref={formRef}
        />
    );
}

export default ClientCont;
